/**
 * Shared IndexedDB store identifiers for the page-side `storage.web.ts`
 * adapter and the service worker's direct `idb-keyval.get()` calls.
 *
 * Lives in its own module so the SW can import the constants without
 * pulling in `storage.web.ts`'s side effects (BroadcastChannel
 * instantiation, listener registration, the `_resetForTests` symbol,
 * and the transitive `@reflecto/client-core` types). Bundling those
 * into the SW would silently inflate `dist/sw.js` and risk SW-context
 * crashes for any future page-only API the adapter starts to use.
 *
 * idb-keyval's default store is a SEPARATE IndexedDB database
 * (`keyval-store` / `keyval`) on the same origin, so the page and the
 * SW must agree on these literals exactly. A rename here is a compile
 * error in both consumers — exactly the failure mode an earlier review
 * cycle flagged when these strings were duplicated.
 */
export const REFLECTO_IDB_DB_NAME = "reflecto";
export const REFLECTO_IDB_STORE_NAME = "kv";

/**
 * Cross-context change-notification channel. `storage.web.ts` publishes every
 * page-side write here so other tabs re-render; the service worker publishes to
 * the SAME channel after its OWN direct-IDB writes (the OS-toast dismiss path),
 * so an open tab's `onChanged`/`useStorage`/Glance driver see SW writes too —
 * without the SW importing `storage.web.ts` (see this module's header). Shared
 * here for the same reason the store names are: a drift is a compile error in
 * both consumers rather than a silent no-fire.
 */
export const REFLECTO_STORAGE_CHANNEL_NAME = "reflecto-storage";
